import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig, { colors } from '@/../themeConfig.js'

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid         : 0,          // From Auth
  displayName : 'Turkish Restaurant', // From Auth
  about       : '',
  photoURL    : require('@/assets/images/logo/logo.png'), // From Auth
  status      : 'online',
  userRole    : 'admin'
}


// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  const mq = function (query) {
    return window.matchMedia(query).matches
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
    return true
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  return mq(query)
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

/*this.$store.commit('TOGGLE_IS_SIDE_MENU_ACTIVE', false)
this.$store.dispatch('updateSideMenuWidth', 'no-nav-menu')
this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')*/
const state = {
  AppActiveUser           : userDefaults,
  bodyOverlay             : false,
  isVerticalNavMenuActive : false,
  isSideMenuActive        : false,
  claimPopup              : false,
  is_touch_device         : is_touch_device(),
  mainLayoutType          : themeConfig.mainLayoutType || 'vertical',
  checkoutLayoutType      : 'vertical',
  navbarSearchAndPinList,
  reduceButton            : themeConfig.sidebarCollapsed,
  sidereduceButton        : themeConfig.sidemenuCollapsed,
  verticalNavMenuWidth    : 'no-nav-menu',
  sideMenuWidth           : 'no-nav-menu',
  verticalNavMenuItemsMin : false,
  sideMenuItemsMin        : false,
  scrollY                 : 0,
  starredPages            : navbarSearchAndPinList['pages'].data.filter((page) => page.is_bookmarked),
  theme                   : themeConfig.theme || 'light',
  themePrimaryColor       : colors.primary,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null
}

export default state
